export default __webpack_public_path__ + "static/media/google-logo.ddcdee8b.svg";